import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { glyphPaths } from '../icons/icon-paths';

function getCssVar(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

const iconIds = [
  'g06', 'g05', 'g04', 'g03', 'g02', 'g01'
];

const FaviconSetter = () => {
  const location = useLocation();
  useEffect(() => {
    const color = getCssVar('--c5') || '#3520D6';
    let step = 0;

    function setFavicon(glyphId) {
      if (!glyphId) return;
      const svgString = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${color}">
          ${glyphPaths[glyphId]}
        </svg>
      `.trim();
      const svgDataUrl = 'data:image/svg+xml;base64,' + btoa(svgString);
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = svgDataUrl;
    }

    const runAnimation = () => {
      if (step < iconIds.length) {
        setFavicon(iconIds[step]);
        step++;
      } else {
        clearInterval(interval);
      }
    };

    // Animate from g06 down to g01
    const interval = setInterval(runAnimation, 250);

    // Run first frame immediately
    runAnimation();

    return () => clearInterval(interval);
  }, [location]);
  return null;
};

export default FaviconSetter; 